import * as React from 'react';
import { ThemeContext } from '../../core/ThemeProvider/ThemeContext.js';
import { isUnitTest } from '../functions/dev.js';
let didLogWarning = {
  fontSize: false,
  themeProvider: false,
};
export const useGlobals = () => {
  let themeContext = React.useContext(ThemeContext);
  useThemeProviderWarning(themeContext);
  useRootFontSizeWarning();
  return themeContext;
};
export const useThemeProviderWarning = (themeContext) => {
  React.useEffect(() => {}, [themeContext]);
};
let useRootFontSizeWarning = () => {
  React.useEffect(() => {}, []);
};
